import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EthWalletService, Wallet } from 'src/app/services/eth-wallet.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-select-wallet',
  templateUrl: './select-wallet.component.html',
  styleUrls: ['./select-wallet.component.scss']
})
export class SelectWalletComponent implements OnInit {
  Wallet = Wallet;
  wallets = [
    {
      name: 'MetaMask',
      icon: 'wallet_metamask_24.svg',
      wallet: Wallet.Software
    },
    {
      name: 'OKX Wallet',
      icon: 'wallet_okxwallet.svg',
      wallet: Wallet.Okx
    }
  ];

  constructor(
    public ngbActiveModal: NgbActiveModal,
    private ethWalletService: EthWalletService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
  }

  connect(wallet: Wallet) {
    this.ethWalletService.connect(wallet).subscribe(
      () => {
        localStorage.setItem('WALLET', wallet.toString());
        this.ngbActiveModal.close(true);
      },
      (e) => {
        console.log(e)
        this.messageService.info('Please login wallet');
      }
    );
  }
}
